import React, { createContext, useContext, useState, useEffect } from 'react';

const DEFAULTS = {
  optimizedPCs: 1700,
  reviewsCount: 1700,
  rating: 4.9,
  satisfiedPercent: 99,
  totalMembers: 1300,
};

const SiteStatsContext = createContext(DEFAULTS);

export const useSiteStats = () => useContext(SiteStatsContext);

export const SiteStatsProvider = ({ children }) => {
  const [stats, setStats] = useState(DEFAULTS);

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    fetch(`${API}/api/site-stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setStats((s) => ({ ...s, ...d })); })
      .catch(() => { /* garde les valeurs par défaut */ });
  }, []);

  return (
    <SiteStatsContext.Provider value={stats}>
      {children}
    </SiteStatsContext.Provider>
  );
};
